export const quickContactReply = `📢 نستقبل أحلامكم والمفسر نفسه عبر:
📞 الاتصال – بوتيم – زوم (خدمة سريعة)
💬 واتساب يومياً (24ساعة) (خدمة سريعة)
📩 SMS الخدمة متاحة مستمرة
📲 للتفاصيل واتساب 00971507354835`;

export const appendQuickReply = (message) => {
  const currentMessage = message || "";

  return currentMessage.trim()
    ? `${currentMessage}\n\n${quickContactReply}`
    : quickContactReply;
};



// WEBPACK FOOTER //
// ./src/utils/quickReplies.js